import type { InterventionsBatchEditContentProps } from "./interventions-batch-edit-content.type";

import BatchTransition from "@/modules/batch-transition";
import InterventionsBatchEditScheduledDate from "@/modules/interventions/interventions-batch-edit-scheduled-date";
import InterventionsBatchEditTemplate from "@/modules/interventions/interventions-batch-edit-template";
import InterventionsBatchEditUsers from "@/modules/interventions/interventions-batch-edit-users";
import SidePanelFormFooter from "@/modules/side-panel-form-footer";

const InterventionsBatchEditContent = ({
  interventions,
  property,
}: InterventionsBatchEditContentProps) => {
  if (property === "state") {
    return <BatchTransition type="intervention" items={interventions} />;
  }

  if (property === "template") {
    return <InterventionsBatchEditTemplate interventions={interventions} />;
  }

  if (property === "scheduled_date") {
    return (
      <InterventionsBatchEditScheduledDate interventions={interventions} />
    );
  }

  if (property === "users") {
    return <InterventionsBatchEditUsers interventions={interventions} />;
  }

  // default footer, with "cancel" button
  return <SidePanelFormFooter hideSubmit />;
};

export default InterventionsBatchEditContent;
